const IS_DEV = process.env.NODE_ENV === 'development';
const API = IS_DEV
  ? '/akademik-api'
  : 'https://akademikfaaliyet.hacettepe.edu.tr/api';
const FAKULTE_ID = 1;
const TIMEOUT_MS = 12000;

let _cache = null;
let _promise = null;

function fetchWithTimeout(url, ms = TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  return fetch(url, { signal: controller.signal })
    .finally(() => clearTimeout(timer));
}

export async function fetchAkademikFaaliyet() {
  if (_cache) return _cache;
  if (_promise) return _promise;

  _promise = (async () => {
    const bolumRes = await fetchWithTimeout(`${API}/bolumler/${FAKULTE_ID}`);
    if (!bolumRes.ok) throw new Error(`Sunucu hatası: ${bolumRes.status}`);
    const bolumData = await bolumRes.json();
    const bolumler = bolumData.data || [];

    const [makalelerResults, projelerResults] = await Promise.all([
      Promise.all(bolumler.map(b =>
        fetchWithTimeout(`${API}/makaleler/${FAKULTE_ID}/${b.id}`)
          .then(r => r.json()).then(d => d.data || []).catch(() => [])
      )),
      Promise.all(bolumler.map(b =>
        fetchWithTimeout(`${API}/projeler/${b.id}`)
          .then(r => r.json()).then(d => d.data || []).catch(() => [])
      )),
    ]);

    _cache = {
      bolumler,
      makaleler: makalelerResults.flat(),
      projeler: projelerResults.flat(),
    };
    _promise = null;
    return _cache;
  })().catch(err => {
    _promise = null;
    throw err;
  });

  return _promise;
}
